

namespace MapConstants{
export const FEATURE_NAME= "featureType";
export const FEATURE_LABEL = 'featureLabel';
export const FEATURE_ID = 'id';
export enum FEATURE_TYPE{blast_polygone, hole, controlPoint};
export const EPSG_REFERENCE_OL: string = 'EPSG:3857';
export const EPSG_WGS84: string = 'EPSG:4326';
export const WGS84: string = '4326';
export const COULEUR_VIOLET_EPC: string = "330,100%,25%";
export const TIR_ID = 'tirId';
export const HOLE_NAME= "holeName";
export const HOLE_ID= "holeId";
export const HOLE_OBJECT= "holeObject";
export const POINT_NAME= "pointName";
export const POLYGONE_TYPE = "polyType";
export const DANGERZONEID = 4;
export const BLAST_NAME = "blastName";
export const COLOR = "color";	
export const KPI = "kpi";
export const EQUIP_TYPE = 'equipmentType';
export const POSITION_DATA = 'positionData';
export const DEFAULT_CORDINATES: number[] = [4.7778, 43.608];
}
export default MapConstants;